module.exports = __webpack_public_path__ + "static/media/Rectangle.65c5f911.png";